module.exports = __webpack_public_path__ + "assets/b011ab0f8b7ce23cc91f1a744b87f672.mp3";